/** @jsxImportSource @emotion/react */
import React from "react";
import "./AmountLabel.css";
import Skeleton from "react-loading-skeleton";
import styled from "@emotion/styled";
import { withIsVisible } from "../../../utils/reactUtils";
import { Amount } from "../../../types/amount";

enum LabelType {
  Primary = "primary",
  Secondary = "secondary",
}
export interface AmountLabelProps {
  amountToDisplay: string;
  labelType: LabelType;
  shouldDisplayShimmer?: boolean;
}

export const AmountLabel = withIsVisible(
  ({ amountToDisplay, labelType, shouldDisplayShimmer }: AmountLabelProps) => {
    return (
      <Container data-sentry-mask="true" data-testid="tradeleg-amount-label" labelType={labelType}>
        {shouldDisplayShimmer || false ? (
          <Skeleton
            baseColor={"#4D5D5D"}
            highlightColor={"#33454566"}
            borderRadius={4}
            width={100}
          />
        ) : (
          amountToDisplay
        )}
      </Container>
    );
  }
);

// Helpers

export const getLabelType = (amount: Amount) => {
  if (amount.value.gt(0)) {
    return LabelType.Primary;
  }
  return LabelType.Secondary;
};

const Container = styled.div<{ labelType: LabelType }>`
  background: none;
  border: 0;
  text-align: right;
  color: ${props =>
    props.labelType === LabelType.Primary
      ? props.theme.font.primary.default
      : props.theme.font.secondary.default};
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  width: 100%;
`;
